// Iconos de marca (Instagram, LinkedIn) que lucide-react eliminó en la v1 por
// tratarse de logos registrados. Se replican con los paths oficiales de lucide
// 0.x y la misma API (`size`) para no cambiar los call sites.
type BrandIconProps = {
  size?: number;
};

const baseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export const Instagram = ({ size = 24 }: BrandIconProps) => (
  <svg width={size} height={size} {...baseProps} aria-hidden="true">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

export const Linkedin = ({ size = 24 }: BrandIconProps) => (
  <svg width={size} height={size} {...baseProps} aria-hidden="true">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);
